module.exports = __webpack_public_path__ + "img/square-caret-right.db7be596.svg";